<template lang="pug">
component.app-result(
	:is="cardIsLink ? 'a' : 'div'" 
	:class="resultClasses"
	:href="cardIsLink ? result.url : false"
	@click.stop="handleLinkClick($event)"
	:style="{'--organization-color': (showBusinessArea ? result.meta.businessAreaColor : null)}"
	:target="isExternalLink ? '_blank' : '_self'"
)
	span.app-result__external-icon.blue-icon-external_bold(v-if="isExternalLink")
	.app-result__media(v-if="renderMediaDiv")
		img.app-result__image(v-if="!!result.image" :src="result.image" :alt="imageAltText" width="450" height="300")
		i.app-result__icon(v-else-if="siteName != 'ORG' || (siteName == 'ORG' && result.contentType == 'event')", :class="result.icon")
	.app-result__content(v-if="siteName == 'ORG' && result.contentType == 'event'")
		span.app-result__access(v-if="result.meta.memberAccess")
			span.app-result__access-icon.blue-icon-locked
			span.app-result__access-text Member Access
		span.app-result__type(v-if="result.meta.type") {{result.meta.type}}
		span.app-result__header {{result.title}}
		.app-result__event-info(v-if="result.meta.location || result.summary || result.meta.preHeader")
			.app-result__event-info-item(v-if="result.meta.preHeader")
				i.app-result__event-info-icon.blue-icon-calendar_thin
				span.app-result__event-info-text(v-html="result.meta.preHeader")
			.app-result__event-info-item(v-if="result.summary")
				i.app-result__event-info-icon.blue-icon-clock
				span.app-result__event-info-text(v-html="result.summary")
			.app-result__event-info-item(v-if="result.meta.location")
				i.app-result__event-info-icon.blue-icon-map-pin_outline_wide
				span.app-result__event-info-text(v-html="result.meta.location")
	.app-result__content(v-else-if="siteName == 'ORG' && result.contentType == 'tasb_service'")
		span.app-result__header {{result.title}}
		span.app-result__copy(v-html="result.summary")
	.app-result__content(v-else-if="siteName == 'CON' && result.contentType == 'session'")
		span.app-result__header {{ result.title }}
		.app-result__session-info-item(v-if="result.meta.sessionDate")
			i.app-result__event-info-icon.blue-icon-clock
			time.app-result__date( :datetime="result.meta.sessionDate") {{ sessionDate }}
		.app-result__session-info-item(v-if="result.meta.roomAndLocation")
			i.app-result__event-info-icon.blue-icon-map-pin_outline_wide
			span.app-result__event-info-text(v-html="result.meta.roomAndLocation")
		.app-result__session-info-item(v-if="result.meta.speaker")
			span.app_result__event-info-label Speaker: 
			span.app-result__event-info-text(v-html="result.meta.speaker")
		.app-result__session-info-item(v-if="result.summary")
			span.app-result__event-info-text(v-html="result.summary")

	.app-result__content(v-else)
		span.app-result__access(v-if="result.meta.memberAccess && result.contentType == 'article'")
			span.app-result__access-icon.blue-icon-locked
			span.app-result__access-text Member Access
		span(v-if="config.showResultType && result.contentType != 'article'" style="display: contents;")
			.app-result__type-container(v-if="siteName == 'ORG' && (result.meta.type || result.icon)")
				i.app-result__type-icon(v-if="result.icon" :class="result.icon")
				span.app-result__type(v-if="result.meta.type" :style="{backgroundColor: config.typeBackground}") {{result.meta.type}}
			span.app-result__type(v-else-if="result.meta.type" :style="{backgroundColor: config.typeBackground}") {{result.meta.type}}
		span.app-result__pre-header(v-if="result.meta.preHeader && siteName !='ORG'") {{result.meta.preHeader}}
		time.app-result__date(v-if="config.showResultDate && !!result.itemDate && siteName == 'ORG' && result.contentType == 'article'" :datetime="result.itemDate") {{ displayDate }}
		span.app-result__header {{result.title}}
		time.app-result__date(v-if="config.showResultDate && !!result.itemDate && siteName == 'ORG' && result.contentType != 'article'" :datetime="result.itemDate") {{ displayDate }}
		span.app-result__copy(v-html="result.summary")
		a.app-result__link(v-if="result.meta.linkText && siteName != 'ORG'" :class="{ 'app-result__link--expand': !result.meta.showDetailPage }" :href="result.url" @click="handleLinkClick($event)" :aria-label="linkLabel" :target="sameOrigin ? '_self' : '_blank'") 
			span {{ result.meta.linkText }}
			span.blue-icon-arrow-right
	.app-result__service(v-if="(showBusinessArea || (result.meta.memberAccess && result.contentType != 'event' && result.contentType != 'article'))")
		.app-result__service-color
		span.app-result__service-name(v-if="showBusinessArea") {{ result.meta.businessAreaName }}&nbsp;
	span.app-result__access(v-if="result.meta.memberAccess && result.contentType != 'event' && result.contentType != 'article'")
		span.app-result__access-icon.blue-icon-locked
		span.app-result__access-text Member Access
	.app-result__highlights(v-if="config.highlightSearchTerms && result.highlights && result.highlights.length > 0")
		span.app-result__highlights-count {{result.highlights.length}} {{result.highlights.length === 1 ? 'mention' : 'mentions'}}
		ul.app-result__highlights-list
			li(v-for="(item, index) in topHighlights" :key="index" v-html="item")
	TransitionExpand
		.app-result__expander(
			v-if="!result.meta.showDetailPage",
			v-show="this.expanded"
			aria-live="polite"
			:aria-hidden="!expanded"
			:style="style")
			button.app-result__expander-close(
				aria-label="Collapse service details"
				@click.prevent.stop="closeExpander"
			)
			.app-result__expander-inner
				span(v-if="!!dropdownContent" style="display: contents;" v-html="dropdownContent")
</template>
	
<script>
	import { format } from "date-fns";
	import { mapGetters } from "vuex";
	import TransitionExpand from "../lib/transitions/ExpandItem";
	
	import sameOriginCheck from "../../global/mixins/sameOriginCheck";

	export default {
		name: "AppResult",
		props: {
			result: Object,
			index: Number,
			results: Array,
		},
		components: {
			TransitionExpand
		},
		data() {
			return {
				containerEl: null,
				containerWidth: null,
				left: null,
				resultRowMates: null,
				expanded: false,
				height: 0,
				currentUrl: window.location,
				dropdownContent: this.result.meta.dropdownContent,
				sameOrigin: sameOriginCheck(this.result.url, window.location),
			};
		},
		computed: {
			...mapGetters([
				"siteName"
			]),
			cardIsLink() {
				return this.result.meta.showDetailPage && (!this.result.meta.linkText || this.siteName == 'ORG');
			},
			cardIsClickable() {
				return this.cardIsLink || !this.result.meta.linkText || this.siteName == 'ORG';
			},
			isExternalLink() {
				return !sameOriginCheck(this.result.url, this.currentUrl);
			},
			showBusinessArea() {
				return this.siteName == 'ORG' &&
					(!document.querySelector(".page--BUY")) && // TASB does NOT want this showing on BuyBoard listing pages as of 08/28/2024
					(this.config.showProvidingOrganization || this.isExternalLink) &&
					!!this.result.meta.businessAreaName;
			},
			resultClasses() {
				return { 
					'app-result--expanded': this.expanded, 
					'app-result--no-media': this.siteName == 'ORG' && (!this.config.showResultImage || !this.result.image),
					'app-result--default-border': !this.config.showProvidingOrganization || !this.result.meta.businessAreaColor || this.result.meta.businessAreaColor == "" || (this.config.showResultImage && this.result.contentType.toLowerCase() == 'event'),
					'app-result--clickable': this.cardIsClickable,
					'app-result--event': this.result.contentType == 'event',
					'app-result--service': this.result.contentType == 'tasb_service',
					'app-result--external': this.isExternalLink,
					'app-result--article': this.result.contentType == 'article',
					'app-result--access': this.result.meta.memberAccess == true,
				}
			},
			imageAltText() {
				return this.result.imageAltText || this.result.meta.imageAltText || this.result.title || "";
			},
			style() {
				return {
					width: `${this.containerWidth}px`,
					maxWidth: `${this.containerWidth}px`,
					left: `${this.left}px`,
				}
			},
			linkLabel() {
				return this.result.meta.showDetailPage ? "" :
					this.expanded ? "Collapse service details" :
					"Expand service details";
			},
			displayDate() {
				return format(new Date(this.result.itemDate), "MMM d, yyyy");
			},
			sessionDate(){
				return format(new Date(this.result.meta.sessionDate), "MMM d, yyyy hh:mm a");
			},
			renderMediaDiv() {
				return this.config.showResultImage && (!!this.result.image || (this.siteName != 'ORG' && !!this.result.icon) || this.result.contentType.toLowerCase() == "event");
			},
			topHighlights() {
				return this.result.highlights.slice(0, 3);
			}
		},
		watch: {
			expanded(newVal, oldVal) {
				this.height = this.$el.querySelector(".app-result__expander-inner").offsetHeight;
			}
		},
		methods: {
			setDataValues() {
				this.containerWidth = this.containerEl.offsetWidth;

				const resultLeft = this.$el.getBoundingClientRect().left;
				const containerLeft = this.containerEl.getBoundingClientRect().left;
				this.left = containerLeft - resultLeft;

				let row = [];
				let top = this.$el.getBoundingClientRect().top;
				const cards = [...this.containerEl.querySelectorAll(".app-result")];
				cards.forEach(c => {
					if (c.getBoundingClientRect().top > (top - 8) && c.getBoundingClientRect().top < (top + 8)) {
						row.push(c);
					}
				});
				this.resultRowMates = row;
			},
			async loadData() {
				if (this.config.previewEndpoint && !this.dropdownContent)
				{
					const response = await fetch(`${this.config.previewEndpoint}/${this.result.key}`, {
						method: 'GET',
						mode: 'cors',
						cache: 'no-cache',
						credentials: 'same-origin',
						redirect: 'follow',
						referrerPolicy: 'no-referrer'
					});

					if (response.ok) {
						this.dropdownContent = await response.text();
					} else {
						this.dropdownContent = '<h3>Sorry, there was an error retrieving this content.</h3>'
					}
				}
			},
			handleLinkClick(e) {
				if (!!e.target.closest(".app-result__expander-inner")) return;
				if (!this.result.meta.showDetailPage) {
					e.preventDefault();
					this.$root.$emit('toggling', this.result.key);
					this.setDataValues();
					const cards = [...this.containerEl.querySelectorAll(".app-result")];
					cards.forEach(c => {
						if (!!c.style.marginBottom) c.style.marginBottom = "";
					})
					this.expanded = !this.expanded;
					if (this.expanded) {
						this.loadData().then(() => {
							this.resultRowMates.forEach(card => {
								const height = this.$el.querySelector(".app-result__expander-inner").offsetHeight;
								card.style.marginBottom = `${height + 16}px`;
							});
							this.setDataValues();
						});
						this.$el.querySelector("button.app-result__expander-close").focus();
					} else {
						this.resultRowMates.forEach(card => card.style.marginBottom = "");
						if (this.result.linkText) this.$el.querySelector("a.app-result__link").focus();
					}
				}
			},
			closeExpander(excludeFocus) {
				this.setDataValues();
				this.expanded = false;
				this.resultRowMates.forEach(card => card.style.marginBottom = "");
				if (!excludeFocus) this.$el.querySelector("a.app-result__link").focus();
			},
		},
		created() { },
		mounted() {
			this.$root.$on('toggling', key => {
				if (key != this.result.key && this.$el.matches(".app-result--expanded")) this.closeExpander(true);
			});
			this.containerEl = this.$el.closest(".app-results");
			if (!!this.$el.querySelector(".app-result__expander")) {
				this.setDataValues();
				this.$el.querySelector(".app-result__expander").style.display = "";
				const cards = [...this.containerEl.querySelectorAll(".app-result")];
				cards.forEach(c => {
					if (c != this.$el) {
						const link = c.querySelector(".app-result__link--expand");
						if (!!link) {
							link.addEventListener("click", () => this.expanded = false);
						}
					}
				});
			}
		},
	};
</script>

<style lang="scss" scoped>
#bluesearch {
	.app-results--list-view .app-result {
		@include mq(sm) {
			flex-direction: row;
			flex-wrap: wrap;
			&__media {
				flex: 0 0 30%;
				}
				img {
					border-top-right-radius: 0;
				}
			&__content {
				flex: 1 0 70%;
				height: auto;
			}
			&__service {
				flex: 1 1 100%;
			}

		}
	}
	.app-result {
		display: flex;
		flex-direction: column;
		border: 1px solid $midGray;
		border-radius: 6px;
		text-decoration: none;
		transition: 0.35s ease;
		position: relative;

		&.app-result--external {
			.app-result__content {
				padding-right: 2.5rem;
			}
			&.app-result--access {
				.app-result__external-icon {
					@include mqdn(md) {
						bottom: unset;
					}
				}
			}
		}

		&__external-icon {
			position: absolute;
			z-index: 1;
			right: 0;
			padding: 10px;
			color: #000;
			background: #ffffffe8;
			border-radius: 50%;
			margin: 5px;
			@include mqdn(md){
				bottom: 0px;
			}
		}
		&--clickable {
			cursor: pointer;
			.page--RM & {
				&:hover,
				&:focus {
					border-color: $blue;
					box-shadow: 0 0 0.35rem rgba($darkGray, 0.2), 0 0 1.25rem rgba($darkGray, 0.1);
				}
			}
		}
		.page--ORG &,
		.page--TXC &,
		.page--TSP &,
		.page--BOB &,
		.page--BUY & {
			box-shadow: 0 0 6px rgba($black, 0.15);
			border-radius: 8px;

			&--no-media:not(.app-result--default-border) {
				border-top: solid 8px var(--organization-color, transparent);
			}
		}
		.page--ORG & {
			&--clickable {
				color: $lightBlackOrg;
				&:hover,
				&:focus {
					background: $lightBlueOrg;
				}
			}
		}
		.page--TSP & {
			&--clickable {
				color: $micrositeblack;
				&:hover,
				&:focus {
					background: lighten($primary100tsp, 5);
				}
			}
		}
		.page--TXC & {
			&--clickable {
				color: $micrositeblack;
				&:hover,
				&:focus {
					background: $accent100txc;
				}
			}
		}
		.page--BOB & {
			&--clickable {
				color: $micrositeblack;
				&:hover,
				&:focus {
					background: $secondary100bob;
				}
			}
		}
		.page--BUY & {
			&--clickable {
				color: $micrositeblack;
				&:hover,
				&:focus {
					background: $secondary100buy;
				}
			}
		}
		.page--ORG &.app-result--service,
		.page--TXC &.app-result--service,
		.page--TSP &.app-result--service,
		.page--BOB &.app-result--service,
		.page--BUY &.app-result--service {
			flex-direction: row;
			flex-wrap: wrap;
			align-items: flex-start;
			gap: 0;

			.app-result {
				&__media {
					flex: 0 0 100px;
					margin: 1.5rem;
					margin-right: 0;
					&::before {
						padding-top: 100%;
					}

					img {
						border-radius: 0;
					}

					@include mq(md) {
						flex: 0 0 132px;
					}
				}
				&__content {
					flex: 1 0 calc(100% - 100px - 2.625rem);
					padding-top: 1.5rem;
					height: auto;
					min-width: 250px;
					margin-bottom: auto;

					@include mq(md) {
						flex: 1 0 calc(100% - 1040px - 2.625rem);
					}
				}
				&__header {
					@include fluid(font-size, 1.25rem, 1.625rem);
					line-height: 1.31;
					margin-bottom: 1rem;
				}
				&__service {
					flex: 1 1 100%;
					margin-top: auto;
					padding-left: 1.5rem;
				}
			}
		}
		.page--ORG &.app-result--service {
			.app-result {
				&__header {
					color: $brightBlueAltOrg;
				}
			}
		}
		.page--TXC &.app-result--service {
			.app-result {
				&__header {
					color: $primary800txc;
				}
			}
		}
		.page--BOB &.app-result--service {
			.app-result {
				&__header {
					color: $primary800bob;
				}
			}
		}
		.page--BUY &.app-result--service {
			.app-result {
				&__header {
					color: $primary800buy;
				}
			}
		}
		.page--TSP &.app-result--service {
			.app-result {
				&__header {
					color: $primary600tsp;
				}
			}
		}

		&__media {
			width: 100%;
			position: relative;
			&::before {
				content: '';
				display: block;
				width: 100%;
				padding-top: 66.6%;
				background: $blue;
				border-radius: 6px 6px 0 0;
			}
			.app-results--list-view & {
				@include mq(sm) {
					flex: 0 0 25%;
					&::before {
						content: unset;
					}
				}
			}
		}

		&__image {
			max-width: 100%;
			height: 100%;
			width: 100%;
			border-radius: 6px 6px 0 0;
			position: absolute;
			object-fit: cover;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
		}

		&__icon {
			position: absolute;
			font-size: 5rem;
			top: 50%;
			left: 50%;
			transform: translateX(-50%) translateY(-50%);
			.page--RM &[class*=blue-icon] {
				color: rgba($white, 0.5);
			}
		}

		&__content {
			display: flex;
			flex-direction: column;
			position: relative;
			padding: 1.5rem 1.25rem 1.875rem;
			height: 100%;
			width: 100%;
			.page--RM & {
				gap: 0.75rem;
			}
			.page--ORG &,
			.page--TXC &,
			.page--TSP &,
			.page--BOB &,
			.page--BUY & {
				gap: 0.25rem;
				padding-top: 1rem;
			}
			.page--ORG .app-result--event &,
			.page--TXC .app-result--event &,
			.page--TSP .app-result--event &,
			.page--BOB .app-result--event &,
			.page--BUY .app-result--event & {
				gap: 0.625rem;
			}
		}

		&__type {
			text-transform: uppercase;
			.page--RM & {
				display: inline-block;
				position: absolute;
				bottom: 100%;
				padding: 0.375rem 0.75rem;
				transform: translateY(50%);
				font-size: 0.875rem;
				line-height: 1.375rem;
				color: $white;
			}
			.page--ORG &,
			.page--TXC &,
			.page--TSP &,
			.page--BOB &,
			.page--BUY & {
				color: $lightBlackOrg;
				font-size: 0.75rem;
				line-height: 1.25rem;

				&-container {
					display: flex;
					align-items: center;
					gap: 0.875rem;
					margin-bottom: 0.375rem;
				}
				&-icon {
					font-size: 1.625rem;
					font-weight: 700;
				}
			}
			.page--ORG & {
				&-icon {
					color: $brightBlueOrg;
				}
			}
			.page--TXC & {
				&-icon {
					color: $purpleTxc;
				}
			}
			.page--BOB & {
				&-icon {
					color: $primarybob;
				}
			}
			.page--BUY & {
				&-icon {
					color: $primarybuy;
				}
			}
			.page--TSP & {
				&-icon {
					color: $primary600tsp;
				}
			}
		}

		&__date {
			text-transform: uppercase;
			font-size: 0.75rem;
			line-height: 1.25rem;
		}

		&__pre-header {
			text-transform: uppercase;
			color: $darkGray;
			font-weight: 500;
			.page--RM & {
				@include fluid(font-size, 1.25rem, 1.75rem);
				@include fluid(line-height, 1.75rem, 2.25rem);
			}
			.page--ORG &,
			.page--TXC &,
			.page--TSP &,
			.page--BOB &,
			.page--BUY & {
				@include fluid(font-size, 1.125rem, 1.375rem);
				@include fluid(line-height, 1.25rem, 2.625rem);
			}
		}
		
		&__header {
			font-weight: 700;
			.page--RM & {
				@include fluid(font-size, 1.125rem, 1.5rem);
				@include fluid(line-height, 1.625rem, 2rem);
				color: $blue;
			}
			.page--ORG &,
			.page--TXC &,
			.page--TSP &,
			.page--BOB &,
			.page--BUY & {
				font-size: 1.125rem;
				line-height: 1.625rem;
				color: $lightBlackOrg;
			}
			.page--ORG .app-result--event &,
			.page--TXC .app-result--event &,
			.page--TSP .app-result--event &,
			.page--BOB .app-result--event &,
			.page--BUY .app-result--event & {
				font-weight: 500;
				font-size: 1rem;
				line-height: 1.5rem;
			}
			.page--ORG .app-result--event & {
				color: $brightBlueAltOrg;
			}
			.page--TXC .app-result--event & {
				color: $purpleTxc;
			}
			.page--BOB .app-result--event & {
				color: $primarybob;
			}
			.page--BUY .app-result--event & {
				color: $primarybuy;
			}
			.page--TSP .app-result--event & {
				color: $primary600tsp;
			}
			.page--ORG .app-result--event:is(a):hover &,
			.page--TXC .app-result--event:is(a):hover &,
			.page--TSP .app-result--event:is(a):hover &,
			.page--BOB .app-result--event:is(a):hover &,
			.page--BUY .app-result--event:is(a):hover & {
				color: $black;
			}
		}

		&__event-info {
			display: flex;
			flex-direction: column;
			gap: 0.375rem;
			margin-top: 0.5rem;
			&-item {
				display: flex;
				align-items: flex-start;
				gap: 0.75rem;
			}
			&-icon {
				width: 1rem;
				min-width: 1rem;
				font-size: 1rem;
				line-height: 1.375rem;
				color: $black;
			}
			&-text {
				font-size: 0.875rem;
				line-height: 1.375rem;
				white-space: pre-wrap;
				color: $black;
			}
		}

		&__copy {
			font-size: 1rem;
			line-height: 1.625rem;
			white-space: pre-wrap;

			& > *:last-child {
				margin-bottom: 0;
			}
			.page--RM & {
				color: $darkGray;
			}
			.page--ORG & {
				color: $lightBlackOrg;
			}
			.page--TXC &,
			.page--BOB &,
			.page--TSP &,
			.page--BUY & {
				color: $micrositeblack;
			}
		}

		&__link {
			font-size: 1rem;
			line-height: 1.5rem;
			display: flex;
			gap: 0.5rem;
			align-items: center;
			color: $red;
			font-weight: 700;
			text-decoration: none;
			margin-top: auto;

			&:hover {
				[class*=icon] {
					transform: translateX(0.5rem);
				}
			}

			[class*=icon] {
				color: $blue;
				font-size: 0.75em;
				transition: 0.2s ease;
				&::before {
					font-weight: 900;
				}
			}
		}

		&__service {
			font-size: 0.75rem;
			line-height: 0.875rem;
			display: flex;
			padding: 1.125rem 2.875rem 1.125rem 1.25rem;
			min-height: 50px;
			border-top: $lightSilverOrg solid 1px;
			gap: 0.5rem;
			flex: 1 0 auto;
			&-color {
				height: 0.875rem;
				width: 0.875rem;
				min-width: 0.875rem;
				border-radius: 50%;
				background-color: var(--organization-color, transparent);
			}
		}

		&__access {
			display: flex;
			gap: 0.5rem;
			align-items: center;
			font-size: 0.875rem;
			line-height: 1.375rem;
			margin-top: auto;
			padding: 0;
			color: $darkGray;
			position: absolute;
			bottom: 0.5rem;
			z-index: 1;
			
			.page--RM & {
				justify-content: flex-end;
				right: 1rem;
			}
			.page--ORG &,
			.page--TXC &,
			.page--TSP &,
			.page--BOB &,
			.page--BUY & {
				width: 2.25rem;
				height: 2.25rem;
				right: 0.375rem;
				border-radius: 50%;
				justify-content: center;
				&-icon {
					display: flex;
					margin-top: -1px;
				}
				&-text {
					@include hideVisually;
				}
			}
			.page--ORG & {
				background: $lightBlueAltOrg;
			}
			.page--TXC & {
				background: $compliantOrangeTxc;
				.app-result__access-icon {
					color: $micrositewhite;
				}
			}
			.page--BOB & {
				background: $accent900bob;
				.app-result__access-icon {
					color: $micrositewhite;
				}
			}
			.page--BUY & {
				background: $secondarybuy;
				.app-result__access-icon {
					color: $micrositeblack;
				}
			}
			.page--TSP & {
				background: $primary100tsp;
			}
		}

		&__expander {
			position: absolute;
			background: $lightestGray;
			overflow: hidden;
			opacity: 0;
			border-radius: 0.5rem;
			top: calc(100% + 1rem);
			transition: inherit;
			transition-property: height, opacity;
			visibility: hidden;
			height: auto;
			cursor: default;
			z-index: 10;
			&-close {
				@include clean(button);
				position: absolute;
				top: 1.25rem;
				right: 1.25rem;
				&::before {
					@include icon;
					content: "\e90e";
					color: $black;
					font-size: 1rem;
					font-weight: 700;
				}
			}
			&-inner {
				padding: 4rem 3.5rem;
				@include wysiwyg;
				@include mqdn(md) {
					padding: 2.25rem 0.5rem 2rem;
				}
			}
		}
		
		.page--ORG &.app-result--event,
		.page--ORG &.app-result--article,
		.page--TXC &.app-result--event,
		.page--TXC &.app-result--article,
		.page--TSP &.app-result--event,
		.page--TSP &.app-result--article,
		.page--BOB &.app-result--event,
		.page--BOB &.app-result--article,
		.page--BUY &.app-result--event,
		.page--BUY &.app-result--article {
			.app-result {
				&__icon {
					color: $white;
					font-size: 6rem;
				}
				&__content {
					padding-bottom: 1.75rem;
					gap: 0.625rem;
					position: relative;
				}
				&__access {
					bottom: unset;
					top: -1.5rem;
					height: 2.75rem;
					width: 2.75rem;
					&-icon {
						font-size: 1.125rem;
					}
				}
				&__header {
					font-weight: 600;
					font-size: 1rem;
					line-height: 1.5rem;
					a {
						display: block;
						text-decoration: none;
						&:hover {
							color: $black;
							text-decoration: none;
						}
					}
				}
			}
		}
		.page--ORG &.app-result--event,
		.page--ORG &.app-result--article {
			.app-result {
				&__header {
					color: $brightBlueAltOrg;
				}
			}
		}
		.page--TXC &.app-result--event,
		.page--TXC &.app-result--article {
			.app-result {
				&__header {
					color: $primary800txc;
				}
			}
		}
		.page--BOB &.app-result--event,
		.page--BOB &.app-result--article {
			.app-result {
				&__header {
					color: $primary800bob;
				}
			}
		}
		.page--BUY &.app-result--event,
		.page--BUY &.app-result--article {
			.app-result {
				&__header {
					color: $primary800buy;
				}
			}
		}
		.page--TSP &.app-result--event,
		.page--TSP &.app-result--article {
			.app-result {
				&__header {
					color: $blueTsp;
				}
			}
		}
		.page--ORG &.app-result--article.app-result--access:not(:has(.app-result__media)),
		.page--ORG &.app-result--article.app-result--access.app-result--external:not(:has(.app-result__media)),
		.page--TXC &.app-result--article.app-result--access:not(:has(.app-result__media)),
		.page--TXC &.app-result--article.app-result--access.app-result--external:not(:has(.app-result__media)),
		.page--TSP &.app-result--article.app-result--access:not(:has(.app-result__media)),
		.page--TSP &.app-result--article.app-result--access.app-result--external:not(:has(.app-result__media)),
		.page--BOB &.app-result--article.app-result--access:not(:has(.app-result__media)),
		.page--BOB &.app-result--article.app-result--access.app-result--external:not(:has(.app-result__media)),
		.page--BUY &.app-result--article.app-result--access:not(:has(.app-result__media)),
		.page--BUY &.app-result--article.app-result--access.app-result--external:not(:has(.app-result__media)) {
			.app-result__external-icon {
				top: 0.25rem;
				right: 3.5rem;
			}
			.app-result__content:first-child,
			span + .app-result__content {
				padding-top: 3rem;
				.app-result__access {
					top: 0.375rem;
				}
			}
		}
		.page--ORG &.app-result--event:is(a):hover,
		.page--TXC &.app-result--event:is(a):hover,
		.page--TSP &.app-result--event:is(a):hover,
		.page--BOB &.app-result--event:is(a):hover,
		.page--BUY &.app-result--event:is(a):hover {
			.app-result {
				&__header {
					color: $black;
				}
			}
		}
	}
	.page--ORG & .app-results--list-view .app-result.app-result--access,
	.page--TXC & .app-results--list-view .app-result.app-result--access,
	.page--TSP & .app-results--list-view .app-result.app-result--access,
	.page--BOB & .app-results--list-view .app-result.app-result--access,
	.page--BUY & .app-results--list-view .app-result.app-result--access {
		.app-result__access {
			@include mq(sm) {
				top: unset;
				bottom: 0.5rem;
			}
		}
	}
	.page--ORG & .app-results--list-view .app-result.app-result--access:has(.app-result__service),
	.page--TXC & .app-results--list-view .app-result.app-result--access:has(.app-result__service),
	.page--TSP & .app-results--list-view .app-result.app-result--access:has(.app-result__service),
	.page--BOB & .app-results--list-view .app-result.app-result--access:has(.app-result__service),
	.page--BUY & .app-results--list-view .app-result.app-result--access:has(.app-result__service) {
		.app-result__access {
			@include mq(sm) {
				bottom: -3rem;
			}
		}
	}
	.page--ORG & .app-results--list-view .app-result,
	.page--TXC & .app-results--list-view .app-result,
	.page--TSP & .app-results--list-view .app-result,
	.page--BOB & .app-results--list-view .app-result,
	.page--BUY & .app-results--list-view .app-result {
		.app-result__media {
			&::before {
				@include mq(sm) {
					border-top-right-radius: 0;
				}
			}
		}
	}
}
</style>